import { SkeletonTable } from "components/layout/skeleton/SkeletonTable";
import { MaxWidthPageWithHeading } from "components/layout/page/MaxWidthPageWithHeading";
import { makeStyles } from "components/providers/makeStyles";
import { useRankingsAndMembershipsPageStyles } from "./useRankingsAndMembershipsPageStyles";

const useStyles = makeStyles((theme) => ({
    page: {
        table: {
            paddingTop: theme.spacing(3)
        }
    }
}));

export const RankingsAndMembershipsPageSkeleton = () => {
    const classes = useRankingsAndMembershipsPageStyles();
    const overrideClasses = useStyles();

    return (
        <div role="status" aria-label="loading">
            <MaxWidthPageWithHeading className={`skeleton ${classes.page} ${overrideClasses.page}`} title="Series">
                <SkeletonTable withoutAvatar />
            </MaxWidthPageWithHeading>
        </div>
    );
};
